import { KEYS } from './constants';

const matchesKeys = (keys) => ({ key }) => keys.includes(key);

export const isActivationKey = matchesKeys(KEYS.ACTIVATE);
export const isNextKey = matchesKeys(KEYS.NEXT);
export const isPrevKey = matchesKeys(KEYS.PREV);
export const isNextHorizontalKey = matchesKeys(KEYS.NEXT_HORIZONTAL);
export const isPrevHorizontalKey = matchesKeys(KEYS.PREV_HORIZONTAL);
export const isNextVerticalKey = matchesKeys(KEYS.NEXT_VERTICAL);
export const isPrevVerticalKey = matchesKeys(KEYS.PREV_VERTICAL);
export const isIncreaseKey = matchesKeys(KEYS.INCREASE);
export const isDecreaseKey = matchesKeys(KEYS.DECREASE);
export const isFirstKey = matchesKeys(KEYS.FIRST);
export const isLastKey = matchesKeys(KEYS.LAST);
export const isEscapeKey = matchesKeys(KEYS.ESCAPE);
export const isTabKey = matchesKeys(KEYS.TAB);

export const onActivationKey = (handler) => (event) => {
  if (isActivationKey(event)) {
    event.preventDefault();
    handler(event);
  }
};
